export default {"src":"/_next/static/media/buy_in_app_40_41x40.c255621e.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};